export interface WorkspaceBranding {
  corporateMode: boolean
  logos: WorkspaceLogos
  colors: WorkspaceColorScheme
  landingPage: WorkspaceLandingPage
}

/**
 * Logos configuration. An empty string means the workspace has no such logo.
 */
export interface WorkspaceLogos {
  /**
   * Logo used for primary things such as headers, splash screens
   */
  primary: string
  /**
   * Same as primary, but to be used on backgrounds of varying (darker) colors.
   */
  primaryWhite: string
  /**
   * Square icon.
   */
  icon: string
  /**
   * Icon, white variant.
   */
  iconWhite: string
}

/**
 * Color scheme.
 */
export interface WorkspaceColorScheme {
  primary: string
}

export interface WorkspaceLandingPage {
  image: string
}

export const WorkspaceBranding = {
  /**
   * Default branding.
   */
  default: {
    colors: { primary: '#000000' },
    logos: { primary: '', icon: '', iconWhite: '', primaryWhite: '' },
    corporateMode: false,
    landingPage: {
      image:
        'https://storage.googleapis.com/worklayer-assets/worklayer-homepage/img_login-worklayer1.svg',
    },
  } as WorkspaceBranding,
}
